import { FiscalCodeLocationDraft, FiscalCodeLocationPayload } from './types'

export const toLocationPayload = (draft: FiscalCodeLocationDraft): FiscalCodeLocationPayload => ({
  code: draft.code.trim().toUpperCase(),
  name: draft.name.trim(),
})
